/**
 * Auth failure handlers for 401/403 responses.
 * Kept thin so transport can call without circular deps (transport -> onAuthFailure -> store).
 */

import { useAppStore } from '../../store';

/** Clear auth-related store state and redirect to login. Used on 401 and on explicit sign out. */
export function clearSessionAndRedirectToLogin(): void {
  const s = useAppStore.getState();
  s.setClerkSignedIn(false);
  s.setCurrentUserId('');
  s.setAuthPending(false);
  if (typeof window !== 'undefined') {
    window.location.href = '/login';
  }
}

/** Redirect to the unauthorized (403) view. Used when server returns 403 Forbidden. */
export function redirectToUnauthorized(): void {
  if (typeof window !== 'undefined') {
    window.location.href = '/app/unauthorized';
  }
}
